function pushIf(map: { [key: string]: boolean }): string[] {
  return Object.entries(map).reduce<string[]>(
    (arr, [key, canPush]) => (canPush ? [...arr, key] : arr),
    [],
  );
}

export { pushIf };
